import { borderRadius, height } from 'styled-system';
import { Image } from 'rebass/styled-components';
import styled from 'styled-components';

export default styled(Image)`
  ${borderRadius}
  ${height}

  &.--is-link {
    cursor: pointer;
  }
`;
